import useMediaQuery from "@mui/material/useMediaQuery";
import type {Theme} from "@mui/material/styles";

export const useOrientation = (): boolean => {
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
	const isLandscape = useMediaQuery("(orientation: landscape)");
	return isMobile && isLandscape;
};

